import React from 'react'
import { pathOr, pipe, map, join } from 'ramda'
import { defaultFilters, defaultNumericFilters, withObjectIds } from '../utils'
import { isRecommended, isClearAll } from './RecommendedJobsFilter/utils'
import { index } from '../../../lib/algolia'
import { getCheckedSections } from './utils'
import { sectionFacetField } from './filterConfig'

const makeSectionsFilter = pipe(
  map(section => `'${sectionFacetField}':"${section}"`),
  join(' OR ')
)

const makeOtherSectionsFilter = pipe(
  map(section => `other_sections:"${section}"`),
  join(' OR ')
)

const addRecommendedIds = (searchState) => {
  const filters = pathOr('', ['configure', 'filters'], searchState)

  if (isRecommended(searchState)) {
    const reccIds = withObjectIds(filters)
    return ` AND (${reccIds})`
  }
}

export const sortSections = (sections) => sections
  .sort((a, b) => a.value.localeCompare(b.value))
  .map(({ value }) => value)

export const Checkbox = ({ label, checked, handleCheck, checkedSections }) => {
  const isChecked = Boolean(checkedSections.find(section => section === label))

  return (
    <ul className='ais-RefinementList-list'>
      <li className='ais-RefinementList-item ais-RefinementList-item--selected'>
        <label className='ais-RefinementList-label'>
          <input className='ais-RefinementList-checkbox' type='checkbox' onChange={handleCheck(label, isChecked)} checked={isChecked} />
          <span className='ais-RefinementList-labelText'>{label}</span>
        </label>
      </li>
    </ul>
  )
}

export default class SectionFilter extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      sections: [],
      checkedSections: []
    }
  }
  componentDidUpdate ({ searchState }) {
    if (searchState && isClearAll(searchState)) {
      this.setState({
        checkedSections: []
      })
    }
  }
  handleCheck = (label, isChecked) => () => {
    const { searchState, onSearchStateChange } = this.props

    const checkedSections = isChecked
      ? this.state.checkedSections.filter(s => !(s === label))
      : [...this.state.checkedSections, label]

    const sectionsFilter = makeSectionsFilter(checkedSections)
    const otherSectionsFilter = makeOtherSectionsFilter(checkedSections)

    let filters = checkedSections.length
      ? `${defaultFilters} AND (${sectionsFilter} OR ${otherSectionsFilter})`
      : defaultFilters

    const reccIds = addRecommendedIds(searchState)
    if (reccIds) {
      filters += reccIds
    }

    const options = {
      configure: { filters }
    }
    onSearchStateChange(options)
    this.setState({
      checkedSections
    })
  }

  checkUrlState () {
    const { searchState } = this.props

    const checkedSections = getCheckedSections(searchState)
    if (checkedSections) {
      this.setState({
        checkedSections
      })
    }
  }

  async componentDidMount () {
    this.checkUrlState()
    const { facetHits } = await index.searchForFacetValues({
      facetName: sectionFacetField,
      facetQuery: '',
      filters: defaultFilters,
      numericFilters: defaultNumericFilters,
      maxFacetHits: 100
    })

    const sections = sortSections(facetHits)
    this.setState({ sections })
  }

  render () {
    const { checkedSections } = this.state
    return (
      this.state.sections.length ? (
        this.state.sections.map((label, i) => (
          <Checkbox handleCheck={this.handleCheck} label={label} checkedSections={checkedSections} key={i} />
        ))
      ) : null
    )
  }
}
